import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "info-with-circle",
  "use": "info-with-circle-usage",
  "viewBox": "0 0 640 640",
  "content": "<symbol viewBox=\"0 0 640 640\" id=\"info-with-circle\"><path d=\"M320 12.8C150.304 12.8 12.768 150.336 12.768 320c0 169.696 137.536 307.232 307.232 307.232 169.632 0 307.2-137.536 307.2-307.232 0-169.664-137.568-307.2-307.2-307.2zm28.672 110.912c29.952 0 38.752 17.376 38.752 37.248 0 24.8-19.84 47.744-53.728 47.744-28.352 0-41.856-14.24-41.024-37.824 0-19.872 16.608-47.168 56-47.168zM271.936 504c-20.48 0-35.424-12.448-21.12-67.008l23.456-96.8c4.064-15.488 4.736-21.696 0-21.696-6.112 0-32.704 10.688-48.384 21.248l-10.208-16.736c49.76-41.568 106.976-65.952 131.456-65.952 20.48 0 23.872 24.192 13.664 61.44l-26.88 101.76c-4.768 17.984-2.72 24.192 2.048 24.192 6.144 0 26.24-7.424 46.016-23.008l11.584 15.552C345.152 485.376 292.384 504 271.936 504z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/info-with-circle.svg
// module id = NG1Y
// module chunks = 1